<span
  class="date"
  [class.date--show-tooltip]="!!tooltipFormat()"
  [attr.title]="
    tooltipFormat() &&
    (date() | ftrDate: { format: tooltipFormat()!, defaultValue: defaultValue(), timeZoneId: timeZone() })
  "
  >{{ date() | ftrDate: { format: format(), defaultValue: defaultValue(), timeZoneId: timeZone() } }}</span
>
